import { render, staticRenderFns } from "./TryUsingAI.vue?vue&type=template&id=b8971620&scoped=true"
import script from "./TryUsingAI.vue?vue&type=script&lang=js"
export * from "./TryUsingAI.vue?vue&type=script&lang=js"
import style0 from "./TryUsingAI.vue?vue&type=style&index=0&id=b8971620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8971620",
  null
  
)

export default component.exports